"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePolicyConfirmationDto = exports.UpdatePolicyConfirmationDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_policy_confirmation_dto_1 = require("./create-policy-confirmation.dto");
class UpdatePolicyConfirmationDocumentDto {
}
exports.UpdatePolicyConfirmationDocumentDto = UpdatePolicyConfirmationDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Id",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyConfirmationDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyConfirmationDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyConfirmationDocumentDto.prototype, "documentId", void 0);
class UpdatePolicyConfirmationDto {
}
exports.UpdatePolicyConfirmationDto = UpdatePolicyConfirmationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyConfirmationDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Status ID",
        required: false,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyConfirmationDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_confirmation_dto_1.PolicyDataWrongSectionDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof create_policy_confirmation_dto_1.PolicyDataWrongSectionDto !== "undefined" && create_policy_confirmation_dto_1.PolicyDataWrongSectionDto) === "function" ? _a : Object)
], UpdatePolicyConfirmationDto.prototype, "policyDataWrongSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_confirmation_dto_1.DeviationSectionDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_policy_confirmation_dto_1.DeviationSectionDto !== "undefined" && create_policy_confirmation_dto_1.DeviationSectionDto) === "function" ? _b : Object)
], UpdatePolicyConfirmationDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_confirmation_dto_1.PolicyDataRectifiedSectionDto),
    tslib_1.__metadata("design:type", typeof (_c = typeof create_policy_confirmation_dto_1.PolicyDataRectifiedSectionDto !== "undefined" && create_policy_confirmation_dto_1.PolicyDataRectifiedSectionDto) === "function" ? _c : Object)
], UpdatePolicyConfirmationDto.prototype, "policyDataRectifiedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [UpdatePolicyConfirmationDocumentDto],
        description: "Array of documents",
        required: true,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdatePolicyConfirmationDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdatePolicyConfirmationDto.prototype, "documents", void 0);
